import script from "./imageSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./imageSlider.vue?vue&type=script&setup=true&lang=js"

import "./imageSlider.vue?vue&type=style&index=0&id=fc7d0222&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7d0222"]])

export default __exports__